import { eventBusMixin } from './eventBusMixins'

export const sidebarChannelRefreshMixin = {
    mixins: [eventBusMixin],
    methods: {
        notifySidebarChannelRefresh(payload = {}) {
            this.emitBus('sidebar-channel:refresh', {
                source: this.$options.name || 'unknown',
                timestamp: Date.now(),
                ...payload,
            })
        },
    },
}

export default sidebarChannelRefreshMixin
